<template>
  <div id="warrantyClaimList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Warranty Claim Queue</div>
          <div class="btn-groups text-right">
            <!-- Button for Clear Cache -->
            <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content warranty-claim-list">

            <div class="btn-groups badge-buttons text-left mb-3">
              <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group"
                   aria-label="Basic example">
                <button type="button" id="getOpenClaims" v-on:click="getOpenClaims(this)"
                        :class="'btn btn-secondary ' + activeOpenClaimTab"> Open
                </button>
                <button type="button" id="getRejectedClaims" v-on:click="getRejectedClaims(this)"
                        :class="'btn btn-secondary ' + activeRejectedClaimTab"> Rejected
                </button>
                <button type="button" id="getAcceptedClaims" v-on:click="getAcceptedClaims(this)"
                        :class="'btn btn-secondary ' + activeApprovedClaimTab"> Accepted
                </button>
                <button type="button" id="getDraftClaims" v-on:click="getDraftClaims(this)"
                        :class="'btn btn-secondary ' + activeCompleteClaimTab"> Draft
                </button>
                <button type="button" id="getAllClaims" v-on:click="getAllClaims(this)"
                        :class="'btn btn-secondary ' + activeAllClaimTab"> All
                </button>
              </div>
            </div>

            <div class="btn-group mb-3">
              <router-link v-if="canAddCom" class="btn btn-primary"
                           v-bind:to="{ name: 'WarrantyClaimCreate' }"><i class="fp-add"></i> Create New
                Claim
              </router-link>
            </div>

            <data-table-filter-config :moduleName="'warrantyClaimList'" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                 :moduleName="'warrantyClaimList'" :position="'top'">
              </custom-pagination>

              <vue-good-table ref="listWarrantyClaimTable" mode="remote" title="Warranty Claims"
                              @on-page-change="onPageChange" @on-selected-rows-change="selectionChanged"
                              @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                              @on-sort-change="onSortChange" :totalRows="totalRecords" :columns="userColumns"
                              :rows="rows" :pagination-options="{
            enabled: false,
            position: 'both',
            perPage: perPage,
            perPageDropdown: dropDownPerPage,
            dropdownAllowAll: false,
        }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
        }" :search-options="{
            enabled: false,
        }">

                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                  <div :key="key">
                    <div
                      v-if="props.column.field == 'attachment_link' && props.row.attachment_link != ''">
                      <a v-on:click="goToGetDocumentPath($event, props.row, 'warranty_claim')"
                         title="Download Attachments" href="" style="font-size: 15px;"><i
                        class="fp-text-document"></i></a>
                    </div>
                    <div v-else-if="props.column.field == 'vin' && canViewAsset === true">
                      <template v-if="props.row.vehicle_id > 0">
                        <router-link title="View VIN" class="color-blue"
                                     v-bind:to="{ name: 'AssetView', params: { id: props.row.vehicle_id }, query: { from: 'warranty-claim' } }">
                          {{ props.row.vin }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ props.row.vin }}
                      </template>

                    </div>
                    <div v-else-if="props.column.field == 'claim_number'">
                      <router-link title="View Claim" class="color-blue"
                                   v-bind:to="{ name: 'WarrantyClaimEdit', params: { id: props.row.id } }">
                        {{ props.row.claim_number }}
                      </router-link>
                    </div>
                    <div v-else-if="props.column.field === 'action'">
                      <template v-if="props.row.allCommentSeen">
                        <svg style="margin-top: -5px;" xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                             width="16" height="16">
                          <title>No New Comment</title>
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"/>
                        </svg>
                      </template>
                      <template v-else>
                        <svg style="margin-top: -5px;stroke: var(--color-orange-rizon);"
                             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             stroke-width="2" width="18" height="18">
                          <title>New Comment(s)</title>
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
                        </svg>
                      </template>
                      <a v-if="falconPermissions" title="Update Falcon Details"
                         v-on:click="showFalconModalPopUp($event, props.row)" href=""><i
                        class="fp-edit"></i></a>

                    </div>
                    <div v-else-if="props.column.field == 'credit_memo_number' && props.row.credit_memo_number != ''">
                      <a class="color-blue" v-on:click="goToGetDocumentPath($event, props.row, 'credit_memo')"
                         title="View Credit Memo Document" href="" style="font-size: 15px;">
                        {{ props.formattedRow[props.column.field] }}
                      </a>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>

                <div slot="selected-row-actions">
                  <button id="deleteItemBtn" v-on:click.prevent="rejectClaim"
                          class="btn btn-danger">Reject
                  </button>
                  <button v-if="velocity_env == 'velev' || velocity_env == 'velev_test'"
                          id="reviewItemBtn" v-on:click.prevent="reviewClaim"
                          class="btn btn-primary">Review
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
        <div class="modal fade" id="falconModal" tabindex="-1" role="dialog">
          aria-labelledby="falconLabel" data-backdrop="static"
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
              </div>
              <div class="pl-5 pr-5 mt-1">
                <h4>Falcon Details</h4>
                <div class="form-row">
                  <div class="col-12 form-group">
                    <div class="d-flex justify-content-between">
                      <label class="control-label require" for="falcon_claim_number">Falcon Claim Number</label>
                    </div>
                    <input type="text" class="form-control" v-model.trim="falcon_claim_number"
                           id="falcon_claim_number" placeholder="Falcon Claim#" name="falcon_claim_number">
                    <span class="field-error">{{ falcon_claim_number_error_msg }}</span>
                  </div>
                  <div class="col-12 form-group">
                    <div class="d-flex justify-content-between">
                      <label class="control-label require" for="falcon_claim_date">Falcon Claim Date</label>
                    </div>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYY" class="form-control" v-model.trim="falcon_claim_date"
                                   id="falcon_claim_date" name="falcon_claim_date" :config="options"></date-picker>
                      <label for="date_of_sale" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <span class="field-error">{{ falcon_claim_date_error_msg }}</span>
                  </div>
                  <div class="col-12 form-group">
                    <div class="d-flex justify-content-between">
                      <label class="control-label require" for="falcon_claim_date">Falcon Internal Notes</label>
                    </div>
                    <textarea type="date" class="form-control" v-model.trim="falcon_internal_notes"
                              id="falcon_internal_notes" placeholder="Falcon Internal Notes"
                              name="falcon_internal_notes">
                    </textarea>
                    <span class="field-error">{{ falcon_internal_notes_error_msg }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-around mt-4 mb-3">
                  <button type="button"
                          id="FalconSubmitBtn" @click="submitFalconDetails()" class="btn-lg btn-primary"
                          style="width: 150px;">Submit
                  </button>
                  <button type="button" @click="closeFalconModal()" class="btn-lg btn-primary"
                          style="width: 150px;">Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import EventBus from "././event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "WarrantyClaimList",
  metaInfo() {
    return {title: "Warranty Claim Queue | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, contractMixins, dataTableMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    velocity_env: process.env.NODE_ENV,
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
      },
      {
        label: 'Id',
        field: 'id',
        filterable: false,
        fpFieldType: "text",
        hidden: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Id", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim Date',
        field: 'claim_date',
        filterable: true,
        fpFieldType: "date",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim Type',
        field: 'claim_type',
        filterable: true,
        fpFieldType: "option",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Type", // placeholder for filter input
          filterDropdownItems: ['Warranty', 'Field Fix', 'Recall', 'PDI', 'NVI', 'Goodwill/Policy', 'OTC Parts'],
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim Status',
        field: 'claim_status',
        filterable: true,
        fpFieldType: "option",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim Status", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: [
            'Accepted',
            'Chargeback',
            'CM Issued',
            'Corrections Made/Dealer Response',
            'Deleted',
            'Draft',
            'In Process',
            'In Review',
            'Modified',
            'Open',
            'Payment Pending',
            'Rejection/Denied',
            'Returned for Corrections',
            'Waiting on Parts'
          ],
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Claim #',
        field: 'claim_number',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Claim #", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'VIN',
        field: 'vin',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "VIN", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Dealer Code',
        field: 'dealer_code',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Dealer Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'RO#',
        field: 'dealer_ro_number',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "RO#", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Failure Date',
        field: 'failure_date',
        filterable: true,
        fpFieldType: "date",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Failure Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Odometer mi.',
        field: 'odometer',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Odometer mi.", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Position Code',
        field: 'position_code',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Position Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Recall / FF#',
        field: 'field_fix_recall',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Recall / FF#", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA#',
        field: 'pwa_number',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA#", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Service Support Case #',
        field: 'support_ticket',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Service Support Case #", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Last Update Date',
        field: 'updated_at',
        filterable: true,
        fpFieldType: "date",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Last Update Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Since Last Update',
        field: 'since_last_update',
        sortable: false,
        filterable: false,
        fpFieldType: "date",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Since Last Update", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Days Open',
        field: 'days_open',
        filterable: false,
        sortable: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Days Open", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Total Claim Amount $',
        field: 'total_requested_amount',
        filterable: true,
        fpFieldType: "integer",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Total Claim Amount $", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Total Approved Amount $',
        field: 'total_approved_amount',
        filterable: true,
        fpFieldType: "integer",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Total Approved Amount $", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'RMA #',
        field: 'rma_number',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "RMA #", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Credit Memo#',
        field: 'credit_memo_number',
        filterable: true,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Credit Memo#", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Credit Memo (CM) Date',
        field: 'credit_memo_date',
        filterable: true,
        fpFieldType: "date",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Credit Memo (CM) Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Attachment(s) Link',
        field: 'attachment_link',
        filterable: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Attachment(s) Link", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,

    loading: false,
    canUpdateCom: false,
    canAddCom: false,
    canAddCollection: false,
    pageKey: "_item_list_",
    action: 'list',
    activeOpenClaimTab: '',
    activeRejectedClaimTab: '',
    activeApprovedClaimTab: '',
    activeCompleteClaimTab: '',
    activeAllClaimTab: '',
    selectedStatus: "",
    canViewAsset: false,
    showFalconModal: false,
    logoPath: '',
    falcon_claim_number: '',
    falcon_claim_number_error_msg: '',
    falcon_claim_date: '',
    falcon_internal_notes: '',
    falcon_claim_date_error_msg: '',
    falcon_internal_notes_error_msg: '',
    options: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
    },
    selectedClaim: "",
    falconPermissions: false,
  }),
  watch: {

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'ev_list_claim') {
            self.cantAccessPage = true;
          }

          if (permissions[i].name == 'ev_add_claim') {
            self.canAddCom = true;
            self.canUpdateCom = true;
          }

          if (permissions[i].name == 'ev_add_claim_collection') {
            self.canAddCollection = true;
          }

          if (permissions[i].name == 'ev_view_vehicle') {
            self.canViewAsset = true;
          }
          if (permissions[i].name === 'ev_claim_falcon_details') {
            self.falconPermissions = true;
            self.showColumns();
          }
        }
      }

    }
  },
  created: function () {
    this.logoPath = process.env.LOGO_PATH;
  },
  mounted: function () {
    var self = this;
    self.getPermissions();

    $('#divTabMenu button').removeClass("active");
    var prevSelectedTab = localStorage.getItem("warranty_claim_prev_tab");

    if (prevSelectedTab == null) {
      self.selectedStatus = "Open";
      self.activeOpenClaimTab = 'active';
      localStorage.setItem("warranty_claim_prev_tab", "open_tab");
    } else {
      if (prevSelectedTab == 'all_tab') {

        self.selectedStatus = "";
        self.activeAllClaimTab = 'active';

      } else if (prevSelectedTab == 'draft_tab') {

        self.selectedStatus = "Draft";
        self.activeCompleteClaimTab = 'active';

      } else if (prevSelectedTab == 'accepted_tab') {

        self.selectedStatus = "Accepted";
        self.activeApprovedClaimTab = 'active';

      } else if (prevSelectedTab == 'rejected_tab') {
        self.selectedStatus = "Rejection/Denied";
        self.activeRejectedClaimTab = 'active';
      } else {

        self.selectedStatus = "Open";
        self.activeOpenClaimTab = 'active';
      }
    }
  },
  methods: {
    showColumns() {
      this.columns.push(
          {
            label: 'Falcon Claim#',
            field: 'falcon_claim_number',
            filterable: true,
            hidden: false,
            fpFieldType: "text",
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Falcon Claim#", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
            }
          },
          {
            label: 'Falcon Submission Date',
            field: 'falcon_submission_date',
            filterable: true,
            hidden: false,
            fpFieldType: "date",
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Falcon Submission Date", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
            }
          },
          {
            label: 'Internal Notes',
            field: 'internal_notes',
            filterable: true,
            hidden: false,
            fpFieldType: "text",
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Internal Notes", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
            }
          }
      );
    },
    cancelAll: function (cancelAll) {
      this.$refs.listWarrantyClaimTable.unselectAllInternal();
    },

    selectionChanged(param) {
      var self = this;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      // console.log(self.computed.selectedRows);
      // var rowData = self.$refs['my-table'].selectedRows;
      // console.log(rowData);
    },
    rejectClaim: function () {
      var self = this;

      var data = this.$refs['listWarrantyClaimTable'].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].status == 'Complete') {
          self.$swal('', 'You cannot reject completed claims', 'info');
          return;
        }
        // use.push(this.$refs['listWarrantyClaimTable'].selectedRows[i].id)
      }

      self.$swal({
        title: 'Are you sure that you want to reject these claim?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          self.action = 'reject';
          self.loadList();
        } else {
          console.log("no");
        }
      });
    },
    reviewClaim() {
      var self = this;
      var data = this.$refs['listWarrantyClaimTable'].selectedRows;
      if (data.length > 1) {
        self.$swal('', 'You cannot review multiple claims', 'warning');
      } else {
        self.$router.push({name: 'EvWarrantyClaimReview', params: {id: data[0].id}});
      }
    },
    loadList() {
      var self = this;

      var data = this.$refs['listWarrantyClaimTable'].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        use.push(this.$refs['listWarrantyClaimTable'].selectedRows[i].id)
      }

      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        // messageData: self.message,
        sort: self.serverParams.sort,
        // exportFiltered: self.exportFilteredFlag
        action: self.action,
        selectedRows: use,
        status: self.selectedStatus,
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/warranty-claim/queue",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            if (self.action === 'reject') {
              self.action = 'list';
              self.loadList();
            } else {
              if (self.action === "export" || self.action === "export_queue") {
                if (data.code === "201") {
                  alert(data.message);
                } else {
                  if (self.action === "export") {
                    self.excel = data.content;
                    var save = document.createElement("a");
                    save.href = self.excel;
                    save.download = data.content;
                    save.target = "_blank";

                    document.body.appendChild(save);
                    save.click();
                    document.body.removeChild(save);

                  } else {

                    self.batchProcess = 1;
                    self.batchNum = data.content;
                  }
                }
                self.action = "list";
              } else {
                self.rows = data.content.row;
                self.totalRecords = data.content.totalRecords;
                self.filteredFlag = false;
              }
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'claim-list')
        }
      });
    },
    getOpenClaims() {
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getOpenClaims').addClass("active");
      localStorage.setItem('warranty_claim_prev_tab', 'open_tab');
      self.selectedStatus = "";
      self.$nextTick(() => {
        self.selectedStatus = "Open";
        self.loadList();
      });
    },
    getAcceptedClaims() {
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getAcceptedClaims').addClass("active");
      localStorage.setItem('warranty_claim_prev_tab', 'accepted_tab');
      self.selectedStatus = "";
      self.$nextTick(() => {
        self.selectedStatus = "Accepted";
        self.loadList();
      });
    },
    getRejectedClaims() {
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getRejectedClaims').addClass("active");
      localStorage.setItem('warranty_claim_prev_tab', 'rejected_tab');
      self.selectedStatus = "";
      self.$nextTick(() => {
        self.selectedStatus = "Rejection/Denied";
        self.loadList();
      });
    },
    getDraftClaims() {
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getDraftClaims').addClass("active");
      localStorage.setItem('warranty_claim_prev_tab', 'draft_tab');
      self.selectedStatus = "";
      self.$nextTick(() => {
        self.selectedStatus = "Draft";
        self.loadList();
      });
    },
    getAllClaims() {
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getAllClaims').addClass("active");
      localStorage.setItem('warranty_claim_prev_tab', 'all_tab');
      self.selectedStatus = "";
      self.$nextTick(() => {
        self.selectedStatus = "";
        self.loadList();
      });
    },
    goToGetDocumentPath(event, row, text) {
      event.preventDefault();
      var self = this;
      if (text == 'warranty_claim') {
        var path = row.attachment_link;
        var flag = text;
        var id = row.id;
      } else {
        var path = row.credit_memo_pdf_path;
        var flag = '';
        var id = row.id;
      }
      self.getDocumentPath(id, path, flag);
    },
    submitFalconDetails() {
      var self = this;
      var validity = this.validateFalconDetails();
      if (validity) {
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/create-falcon-details",
          type: "POST",
          headers: this.ajxHeaders,
          data: {
            falcon_claim_number: self.falcon_claim_number,
            falcon_claim_date: self.falcon_claim_date,
            falcon_internal_notes: self.falcon_internal_notes,
            claim_id: self.selectedClaim,
          },
          dataType: 'json',
          success: function (data) {
            self.loading = false;
            self.closeFalconModal();
            self.loadList();
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.closeFalconModal();
            self.generateStatusCodeMessage(jqXHR, true, 'falcon-details-create')
          }
        });
      }
    },
    closeFalconModal() {
      this.falcon_claim_number = "";
      this.falcon_claim_date = "";
      this.falcon_internal_notes = "";
      this.clearFalconErrorMessages();
      this.showFalconModal = false;
      this.selectedClaim = "";
      $('#falconModal').modal('hide');
    },
    showFalconModalPopUp(event, row) {
      event.preventDefault();
      this.clearFalconErrorMessages();
      this.falcon_claim_number = row.falcon_claim_number;
      this.falcon_claim_date = row.falcon_submission_date;
      this.falcon_internal_notes = row.internal_notes;
      this.showFalconModal = true;
      this.selectedClaim = row.id;
      $('#falconModal').modal('show');
    },
    validateFalconDetails() {
      var valid = true;
      this.clearFalconErrorMessages();
      if (this.falcon_claim_number === "" || this.falcon_claim_number === null) {
        this.falcon_claim_number_error_msg = "Falcon Claim Number is Required!";
        valid = false;
      }

      if (this.falcon_claim_date === "" || this.falcon_claim_date === null) {
        this.falcon_claim_date_error_msg = "Falcon Claim Date is Required!";
        valid = false;
      }

      if (this.falcon_internal_notes === "" || this.falcon_internal_notes === null) {
        this.falcon_internal_notes_error_msg = "Internal Notes is Required!";
        valid = false;
      }

      return valid;
    },
    exportCheck: function () {
      var actionFlag = "";
      var data = this.$refs['listWarrantyClaimTable'].selectedRows;
      var count = data.length;
      if (this.serverParams.selectedAll === true) {
        actionFlag = "";
      } else if (count !== 0 && count <= 100) {
        actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },
    clearFalconErrorMessages() {
      this.falcon_claim_number_error_msg = "";
      this.falcon_claim_date_error_msg = "";
      this.falcon_internal_notes_error_msg = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/WarrantyClaimList.vue